import type { UpdateProfileDto } from '../dto';
import type { UpdateProfile } from '../models';

export const mapUpdateProfileToDto = (
  model: UpdateProfile,
): UpdateProfileDto => ({
  clientId: model.clientId,
  recommendedProfile: model.recommendedProfile,
  authorizedProfile: model.authorizedProfile,
  authorizationProfileDate: model.authorizationProfileDate,
});

export const mapUpdateProfileDtoToModel = (
  dto: UpdateProfileDto,
): UpdateProfile => ({ ...dto });
